<template>
    <x-layout class="wizard-header">
        <x-flex xs3 align-self-center>
            <h3>{{ title }}</h3>
        </x-flex>

        <x-flex
            v-for="(step, index) in steps"
            :key="index"
            class="wizard-header-step"
            :class="{
                'wizard-header-step--active': (!isComplete && currentStep === index + 1),
                'wizard-header-step--complete': (isComplete || currentStep > index + 1),
            }"
        >
            <div class="wizard-header-step__number">0{{ index + 1 }}</div>

            <div class="wizard-header-step__text">{{ step }}</div>

            <div class="wizard-header-step__complete"><i class="material-icons">done</i></div>
        </x-flex>
    </x-layout>
</template>

<script>
export default {
    name: 'WizardHeader',
    props: {
        title: String,
        steps: Array,
        currentStep: Number,
        isComplete: Boolean,
    }
}
</script>

<style scoped lang="scss">
.wizard-header {
    .wizard-header-step {
        position: relative;
        flex: 1;
        opacity: 0.7;
        border-radius: 8px 8px 0 0;
        border-bottom: 2px solid transparent;
        padding: 16px 16px 12px;
        background: transparent;
        transition: all $transition-length;

        &:not(:last-child) {
            margin-right: 8px;
        }

        &__number {
            margin-bottom: 6px;
            font-family: $font-title;
            font-size: rem(24px);
        }

        &__text {
            font-weight: 600;
        }

        &__complete {
            position: absolute;
            top: 16px;
            right: 16px;
            opacity: 0;
            transition: opacity $transition-length;
        }

        &--active {
            opacity: 1;
            border-color: $color-secondary;
            background: rgba(255, 255, 255, 0.1);

            .wizard-header-step__text {
                color: $color-secondary;
            }
        }

        &--complete {
            opacity: 1;
            color: rgba(255, 255, 255, 0.7);
            background: rgba(255, 255, 255, 0.03);

            .wizard-header-step__complete {
                opacity: 1;
            }
        }
    }
}
</style>
